export const DEV_MODE = import.meta.env.VITE_DEV_MODE === 'true';
export const BILLING_INTERNAL_API_KEY = (import.meta.env.VITE_BILLING_INTERNAL_API_KEY ?? '').trim();
